import builder from '../builder';
import PictureSun from '../../streamline-icons/light/picture-sun.svg';

export default builder('IconPictureSunLight', PictureSun);
